import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../route';
import { IntegrationsListPage } from './IntegrationsListPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/integrations',
  staticData: {
    app: {
      access: {
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.Integration },
        ],
      },
    },
  },
  component: IntegrationsListPage,
  loader: () => ({
    crumb: msg('Integrations', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Integration,
      redirectTo: '/',
    });
  },
});
